import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const LeaderboardPage = ({ setToken }) => {
  useEffect(() => {
    getLeaderboard();
  }, []);

  const [users, setUsers] = useState([]);

  const getLeaderboard = () => {
    fetch("https://bb-exchange.herokuapp.com/leaderboard")
      .then((resp) => resp.json())
      .then(function (response) {
        setUsers(response.leaderboard);
        return response;
      });
  };

  return (
    <div>
      <h1 style={{ marginTop: "0px" }}>Leaderboard</h1>

      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "40px" }} align="center">
                Placement
              </TableCell>
              <TableCell align="center">User</TableCell>
              <TableCell align="center">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((row, index) => (
              <TableRow key={row._id}>
                <TableCell style={{ width: "40px" }} align="center">
                  #{index + 1}
                </TableCell>
                <TableCell align="center">{row.username}</TableCell>
                <TableCell align="center">${row.total.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default LeaderboardPage;
